import { useQuery } from '@tanstack/react-query'
import { DetailSection, QueryBlock } from '../../core/index.js'
import type { MessagesAdminApi } from '../adminApi.js'
import { SentMessageList } from '../components/MessageWorkersCard.js'

/** The admin's read-only list of the messages staff sent at a facility (SMS plan 3.7), each opening to its reach. */
export function AdminFacilityMessagesSection({ api, clientId, facilityId }: { api: Pick<MessagesAdminApi, 'facilityMessages' | 'facilityMessage'>; clientId: string; facilityId: string }) {
  const query = useQuery({ queryKey: ['admin', 'facility', clientId, facilityId, 'messages'], queryFn: () => api.facilityMessages(clientId, facilityId) })
  return (
    <DetailSection title="Messages staff sent" endpoint="…/messages">
      <QueryBlock query={query} missing="This facility no longer exists.">
        {(messages) => <SentMessageList messages={messages} reachOf={(messageId) => api.facilityMessage(clientId, facilityId, messageId)} empty="Nothing sent yet. An operator or a facility administrator writes to workers from the Tools tab or a roster row's Messages tab." />}
      </QueryBlock>
    </DetailSection>
  )
}
